import { buildApiUrl } from '../utils/apiSetup';
const authHeaders = (json = true) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` };
  if (json) headers['Content-Type'] = 'application/json';
  return headers;
};

const parseError = async (response, fallback) => {
  try {
    const data = await response.json();
    if (typeof data.detail === 'string') return data.detail;
  } catch {
    /* ignore */
  }
  return fallback;
};

export async function fetchEmployeeForms(signal) {
  const response = await fetch(buildApiUrl('/api/v1/employee/forms'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load employee forms'));
  return response.json();
}

export async function fetchFormOverview(code, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employee/forms/${code}`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load form overview'));
  return response.json();
}

export async function fetchFormSubmission(code, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employee/forms/${code}/submission`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load form submission'));
  return response.json();
}

export async function saveDraft(code, formData, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employee/forms/${code}/draft`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ form_data: formData }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to save draft'));
  return response.json();
}

export async function submitForm(code, formData = null, remarks = null, signal) {
  const payload = {};
  if (formData !== null) payload.form_data = formData;
  if (remarks !== null) payload.remarks = remarks;

  const response = await fetch(buildApiUrl(`/api/v1/employee/forms/${code}/submit`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to submit form'));
  return response.json();
}

export async function adminSaveDraft(employeeId, code, formData, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employees/${employeeId}/joining-forms/${code}/draft`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ form_data: formData }),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to save draft'));
  return response.json();
}

export async function adminSubmitForm(employeeId, code, formData = null, remarks = null, signal) {
  const payload = {};
  if (formData !== null) payload.form_data = formData;
  if (remarks !== null) payload.remarks = remarks;

  const response = await fetch(buildApiUrl(`/api/v1/employees/${employeeId}/joining-forms/${code}/submit`), {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
    signal,
  });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to submit form'));
  return response.json();
}

export async function adminFetchFormSubmission(employeeId, code, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employees/${employeeId}/joining-form-submissions`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load form submission'));
  const submissions = await response.json();
  const match = submissions.find(s => s.form_code === code);
  if (!match) throw new Error('Submission not found');
  return match;
}

export async function fetchEmployeeSubmissions(signal) {
  const response = await fetch(buildApiUrl('/api/v1/employee/submissions'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load employee submissions'));
  return response.json();
}

export async function fetchFormStatus(code, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employee/forms/${code}/status`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load form status'));
  return response.json();
}

export async function fetchEmployeeProfile(signal) {
  const response = await fetch(buildApiUrl('/api/v1/employee/profile'), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load employee profile'));
  return response.json();
}

export async function adminFetchEmployeeProfile(employeeId, signal) {
  const response = await fetch(buildApiUrl(`/api/v1/employee-master/${employeeId}/profile-360`), { headers: authHeaders(false), signal });
  if (!response.ok) throw new Error(await parseError(response, 'Failed to load employee profile for admin'));
  const data = await response.json();
  
  return {
    full_name: data.personal?.full_name,
    emp_code: data.personal?.emp_code,
    department: data.employment?.department,
    designation: data.employment?.designation,
    date_of_birth: data.personal?.date_of_birth,
    date_of_joining: data.employment?.join_date,
    date_of_retirement: data.employment?.retirement_date,
    permanent_address: data.personal?.permanent_address,
    current_address: data.personal?.current_address,
  };
}
